import { FeatureFlag } from '@sonar-software/sonar-core';
import { isFunction } from '@sonar-software/sonar-ts-lib';
import React from 'react';
import { useFeatureFlag } from '@hooks';

export interface FeatureBoundaryProps {
	children: React.ReactNode | (() => React.JSX.Element);
	feature: FeatureFlag;
}

export const FeatureBoundary: React.FC<FeatureBoundaryProps> = ({ children, feature }) => {
	const isFeatureEnabled = useFeatureFlag(feature);

	if (!isFeatureEnabled) {
		return null;
	}

	if (isFunction(children)) {
		return <>{ children() }</>;
	}

	return children as React.ReactElement;
};
